export function printSlug(slug) {
  if(!slug) return '';
  return slug.split(/[-_]/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}